import { persist, createSessionStorage, setSerialization } from '@macfja/svelte-persistent-store';
import { writable } from 'svelte/store';import { customSerialization } from './serialization.js';

setSerialization(...customSerialization);

export const newAssignmentFromResources = writable();
export const nextDueAssignment = writable();

export const lastDocumentViewerItem = persist(writable(null), createSessionStorage(), 'lastDocumentViewerItem');
export const lastArmedDocumentViewerItem = persist(writable(null), createSessionStorage(), 'lastArmedDocumentViewerItem');

export const showAuthModal = writable(false);

export const showResourceHub = writable();

export const showNewEntityModal = writable();

export const showNewEntityTypeModal = writable();

export const showNewUserModal = writable();

export const showNewRoleModal = writable();

export const showSubscriptionsModal = writable();

export const showInvitationCodesModal = writable();

export const showUserSettingsModal = writable();

export const showTranslationSettingsModal = writable();

export const showClassSettingsModal = writable();

export const showAddCodeModal = writable();

export const showLoader = writable('Loading...');

export const dbCalls = writable();

export const showNewsWidget = writable();

export const showRemindersWidget = writable();